import React, { useEffect, useState } from "react"
import NoteAdded from "./components/NoteAdded";
import Finalized from "./components/Finalized";
import Unassigned from "./components/Unassigned";
import TagAssigned from "./components/TagAssigned";
import PropertySaved from "./components/PropertySaved";
import ScanPerformed from "./components/ScanPerformed";
import PathConnectors from "./components/PathConnectors/PathConnectors";
import TargetsUpdated from "./components/TargetsUpdated";
import AssigneesUpdated from "./components/AssigneesUpdated";
import UploadSuccessful from "./components/UploadSuccessful";
import FieldValueProvided from "./components/FieldValueProvided";
import UnderInvestigation from "./components/UnderInvestigation";
import DiscrepancyResolvedOrRejected from "./components/DiscrepancyResolvedOrRejected";
import ManualInvestigation from "./components/ManualInvestigation";
import TargetOutcomeUpdated from "./components/TargetOutcomeUpdated";
import FinancialInfoProvided from "./components/FinancialInfoProvided";
import PublicRecordsConfirmed from "./components/PublicRecordsConfirmed";
import DiscrepanciesAllResolved from "./components/DiscrepanciesAllResolved";
import DiscrepancyEditedOrRejected from "./components/DiscrepancyEditedOrCreated";
import { TimelineCard, TimelineEvent, TimelineScroll } from "./TimelineLayout";

const Timeline = ({ timeline, origin }) => {
  const [viewingTimeline, setViewingTimeline] = useState(null)

  useEffect(() => {
    if (timeline) {
      setViewingTimeline([...timeline].reverse())
    }
  }, [timeline])

  return (
    <TimelineScroll $variant={origin}>
      {viewingTimeline && viewingTimeline.map((milestone, index) => (
        <TimelineEvent key={`${milestone.milestone}${index}`} className={index === 0 ? "first" : ""}>
          <TimelineCard>
            <PathConnectors milestone={milestone} mapIndex={index} timeline={viewingTimeline} />
            {milestone.milestone === 'Refinance Targets Updated' ?
              <TargetsUpdated milestone={milestone} />
            : milestone.milestone.includes('Target Outcome') ?
              <TargetOutcomeUpdated milestone={milestone} />
            : milestone.milestone === 'Refinance Investigation Opened' || milestone.milestone === 'Renegotiation Investigation Opened' ?
              <UnderInvestigation milestone={milestone} />
            : milestone.milestone === 'Lead Tag Created & Assigned' || milestone.milestone === 'Lead Tag Assigned' || milestone.milestone === 'Mortgage Tag Created & Assigned' || milestone.milestone === 'Mortgage Tag Assigned' ?
              <TagAssigned milestone={milestone} />
            : milestone.milestone === 'Manual Refinance Investigation Opened' || milestone.milestone === 'Manual Renegotiation Investigation Opened' ? 
              <ManualInvestigation milestone={milestone} />
            : milestone.milestone.includes('Lead Assignees Updated') || milestone.milestone.includes('Mortgage Assignees Updated') ?
              <AssigneesUpdated milestone={milestone} />
            : milestone.milestone === 'Note Added' ?
              <NoteAdded milestone={milestone} origin={origin} />
            : milestone.milestone === 'Discrepancies Detected' || milestone.milestone === 'New Discrepancies Discovered' || milestone.milestone === 'Public Records Updated' || milestone.milestone === 'Record Scanned Successfully' || milestone.milestone === 'Initial Scan Successful' ?
              <ScanPerformed milestone={milestone} />
            : milestone.milestone.includes('Record Provided') ?
              <FieldValueProvided milestone={milestone} />
            : milestone.milestone.includes('Discrepancy Resolved') || milestone.milestone.includes('Discrepancy Rejected') ?
              <DiscrepancyResolvedOrRejected milestone={milestone} />
            : milestone.milestone.includes('Discrepancy Edited') || milestone.milestone.includes('Discrepancy Created') || milestone.milestone === 'Internal Records Updated' ?
              <DiscrepancyEditedOrRejected milestone={milestone} />
            : milestone.milestone.includes('Finalized') ?
              <Finalized milestone={milestone} origin={origin} />
            : milestone.milestone === 'All Discrepancies Resolved' ?
              <DiscrepanciesAllResolved milestone={milestone} />
            : milestone.milestone === 'Property Uploaded Successfully' || milestone.milestone === 'File Upload' ?
              <UploadSuccessful milestone={milestone} />
            : milestone.milestone === 'Public Records Verified' ?
              <PublicRecordsConfirmed milestone={milestone} />
            : milestone.milestone === 'Property Saved from Search' ?
              <PropertySaved milestone={milestone} />
            : milestone.milestone === 'Financial Information Provided' ?
              <FinancialInfoProvided milestone={milestone} />
            :
              <Unassigned milestone={milestone} />
            }
          </TimelineCard>
        </TimelineEvent>
      ))}
    </TimelineScroll>
  )
}

export default Timeline
